import React from 'react'
import { Grid, GridItem } from '../../grid/Grid.jsx'
import { constants } from './constants.js'
import { getMargins } from '../../../utility/index.js'
import ButtonLinkCtaList from '../../link/buttonLinkCtaList.jsx'
import DOMPurify from 'dompurify'
import { BannerCutout } from './BannerCutout.jsx'

export const HeroBanner = ({
  backgroundColor = 'dark',
  imageUrl = '',
  bgImageUrl = '',
  mobileImageUrl = '',
  columnCount = 'thirds',
  textColor = 'white',
  primaryHeading = '',
  secondaryHeading = '',
  secondaryHeadingColor = 'inherit',
  eyebrowColor = 'white',
  eyebrowText = '',
  eyebrowFont = 'Publico',
  verticalPadding = 8,
  angleType = 'content',
  angleBorder = 'double',
  linkList = [],
  angleBorderColor = 'white',
  width = 'full',
  contentAlignment = '',
  isMobile = false,
  horizontalCrop = 'center',
  verticalCrop = 'top',
  marginTop = 'No Spacing',
  marginBottom = 'No Spacing',
  backgroundPosition,
  backgroundSize,
}) => {
  const bgClass = constants.backgroundColors[backgroundColor] || ''
  const textColorClass =
    textColor === 'black' ? 'u-textColorBlack' : 'u-textColorWhite'
  const eyebrowFontClass = eyebrowFont === 'Roboto' ? 'roboto-font' : ''
  const eyebrowColorClass = constants.textColors[eyebrowColor]

  const shouldConstrain = width === 'full' && bgImageUrl
  const contentWidthClass = shouldConstrain ? 'u-sizeConstrained' : ''
  const backgroundWidthClass = !shouldConstrain ? 'u-sizeConstrained' : ''

  let widthClass = ''
  if (imageUrl && width === 'inset') {
    widthClass = 'u-sizeConstrained u-paddingRight0'
  }
  const backgroundPositionClass =
    constants.background.position[backgroundPosition] || 'background-pos-center'

  const backgroundSizeClass =
    constants.background.size[backgroundSize] || 'background-size-cover'

  const contentAlignmentClass =
    contentAlignment === 'center' ? 'u-flexAlignItemsCenter' : ''

  const gridSizeContent = {
    whole: 'u-sizeFull',
    fourths: 'u-size3of4',
    thirds: 'u-size2of3',
    halves: 'u-size1of2',
  }

  const Cutout = (
    <BannerCutout
      columnCount={columnCount}
      angleBorder={angleBorder}
      angleType={angleType}
      angleBorderColor={angleBorderColor}
      bgClass={bgClass}
      imageUrl={imageUrl}
      horizontalCrop={horizontalCrop}
      verticalCrop={verticalCrop}
      isMobile={isMobile}
      mobileImageUrl={mobileImageUrl}
    />
  )

  return (
    <div className={`Banner ${bgClass} ${widthClass}`}>
      {width !== 'inset' && Cutout}
      <div
        className={`Content-container u-posRelative ${getMargins(
          marginTop,
          marginBottom
        )} u-overflowHidden u-flex u-sm-flexWrap u-sm-flexColReverse ${backgroundWidthClass} ${isMobile ? ` ${bgClass}` : ''}`}
      >
        <div
          className={`content backgroundImage ${backgroundPositionClass} ${backgroundSizeClass} u-posRelative ${gridSizeContent[columnCount]} u-sm-sizeFull`}
          style={{
            backgroundImage: bgImageUrl ? `url("${bgImageUrl}")` : 'none',
          }}
        >
          <Grid>
            <GridItem
              className={`u-paddingVert${verticalPadding}gu  u-flex u-flexCol  ${contentAlignmentClass} u-flexJustifyCenter  u-md-sizeFull u-sm-sizeFull ${textColorClass} ${contentWidthClass}`}
              columnCount="1"
              gridSize="1"
            >
              {eyebrowText && (
                <div
                  className={`eyebrow u-textSizeMsrp1 u-sm-textSizeMsr ${eyebrowFontClass} ${eyebrowColorClass}`}
                >
                  {eyebrowText}
                </div>
              )}
              {primaryHeading && (
                <div
                  className="primaryHeading"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(primaryHeading),
                  }}
                />
              )}
              {secondaryHeading && (
                <div
                  className={`secondaryHeading u-textSizeMsrp2 u-sm-textSizeMsrp1 u-paddingTop4gu ${secondaryHeadingColor}`}
                >
                  {secondaryHeading}
                </div>
              )}

              {linkList && linkList.length > 0 && (
                <div className="u-marginTop6gu">
                  <ButtonLinkCtaList linkList={linkList} />
                </div>
              )}
            </GridItem>
          </Grid>
        </div>
        {width == 'inset' && Cutout}
      </div>
    </div>
  )
}
